import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import StocksandEFTs from '../components/ui-components/money-tab/StocksandEFTs';
import AddIcon from "@mui/icons-material/Add";
import { getURLBase, updateParentHeight } from "../utils/helperFns";
import { Button } from "@mui/material";
import {GradientButton} from "../components/ui-components/GradientButton";
import axios from "axios";


export class TotalInvestments extends Component {
  
  constructor(props) {
    super(props)
    this.url = getURLBase(true) + '/invest'
    this.state = {
        showStocksandEFTs: false,
        isReady: false,
        total : 0,
        stock_and_efts: 0,
        funds: 0,
    }
}

componentDidMount() {
    if (!this.state.isReady) {

        axios.post(this.url, { gid: this.props.gid }).then(
            (response) => {
                this.setState(response.data.body)
                this.setState({ isReady: true })
            }
        )
    }
}
  toggleStocksandEFTs = () => {
    var show = this.state.showStocksandEFTs;
    show = !show;
    this.setState({ showStocksandEFTs: show },
      () => {
        updateParentHeight("parent_TotalInvestments","child_StocksandEFTs",this.state.showStocksandEFTs);
      });
}

  render() {
    const WidgetData = () => (
      // <Card className="widgetCard cardShadow" id="parent_TotalInvestments">
      <Card className="widgetCard cardShadow" id="parent_TotalInvestments">
          <Typography variant="h4" sx={{ fontWeight: 700 }} align="center" gutterBottom>
            Total Investments
          </Typography>
        <CardContent >
        
 
          <Typography
            variant="h2"
            color="primary.main"
            align="center"
            marginBottom={5}
            gutterBottom
          >
            £ {this.state.total}
          </Typography>
          <Grid
              container sx={{marginX:"auto"}} maxWidth={420}>

            <Grid
              container
              columnSpacing={{xs:0,sm:2}}
              rowGap={2}
              className={this.state.total === null || this.state.funds === null || this.state.stock_and_efts === null ? "blur" : ""}
              
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                 <Button variant="text" sx={{width:"100%",padding:0}}
                 onClick={ this.state.total === null ? null : () => {
                  this.toggleStocksandEFTs()
                  }  }
              >
                <Box
                  p={3}
                  boxShadow={4}
                  sx={{borderRadius:2,width:"100%"}}
                >
                  <Typography
                    variant="subtitle1"
                    marginBottom={2}
                    fontWeight="700"
                    align="center"
                    gutterBottom
                  >
                    Stocks & ETFs
                  </Typography>
                  <Typography variant="h3" align="center">£ 0</Typography>
                </Box>
                </Button>
              </Grid>

              <Grid
                item
                md={6}
                xs={12}
              >
                <Button variant="text" sx={{width:"100%",padding:0}}>
                 <Box
                  p={3}
                  boxShadow={4}
                  sx={{borderRadius:2,width:"100%"}}
                >
                  <Typography
                    variant="subtitle1"
                    marginBottom={2}
                    fontWeight="700"
                    align="center"
                    gutterBottom
                  >
                    Funds
                  </Typography>
                  <Typography variant="h3" align="center">£ 0</Typography>
                </Box>
                </Button>
              </Grid>
            </Grid>
  </Grid>
          <Box className="flex-center-all" marginTop={5}>
            <GradientButton
              className="flex-center-all"
              startIcon={<AddIcon/>}
              sx={{ maxWidth: "100%",width: 360, textTransform:"capitalize", fontWeight:700}}
            >
              
             Add Account
            </GradientButton>
          </Box>
        </CardContent>

        {
                    this.state.showStocksandEFTs ?
                        <StocksandEFTs
                        grandparentExist={false}
                            toggleHandler={this.toggleStocksandEFTs} />
                        : null
                }

      </Card>
    );

    return (
      <>
        <WidgetData />
      </>
    );
  }
}

export default TotalInvestments;
